export default {
    header: {
        telefone: "Telefone",
        signIn: "Entrar",
        register: "Registrar",
        becomeExpert: "Registre sua empresa",
        dashboard: "Painel",

        sidebar: {
            tuktuk: {
                title: "Tuk Tuk",
                subtitle: "Reserva de Tuk Tuk",
                menu: {
                    grid: "Listagem de Tuk Tuk",
                },
            },
            about: {
                title: "Sobre",
                subtitle: "Sobre",
                menu: {
                    aboutUs: "Sobre Nós",
                    testimonials: "Depoimentos",
                    faq: "Perguntas Frequentes",
                    contact: "Fale Conosco",
                    terms: "Termos e Condições",
                    privacy: "Política de Privacidade",
                },
            },
            dashboard: {
                title: "Painel",
                subtitle: "Painel do Utilizador",
                subtitle2: "Painel do Agente",
                menu: {
                    dashboard: "Painel",
                    myBookings: "Minhas Reservas",
                    reviews: "Avaliações",
                    support: "Suporte",
                    wishlist: "Lista de Desejos",
                    wallet: "Carteira",
                    profileSettings: "Definições de Perfil",
                    notifications: "Notificações",
                    myProfile: "Meu Perfil",
                    settings: "Definições",
                    dashboard2: "Painel",
                    bookings: "Reservas",
                    enquiries: "Consultas",
                    earnings: "Ganhos",
                    reviews2: "Avaliações",
                    settings2: "Definições",
                },
            },
            social: {
                title: "Rede Social",
                subtitle: "Feed de Postagens",
                menu: {
                    feed: "Feed",
                    myProfilePage: "Minha Página de Perfil",
                    explore: "Explorar",
                },
            },
        },
    },

    common: {
        welcome: "Bem-vindo, {{name}}!",
    },

    home: {
        hero: {
            title: "Aproxime-se do sonho:",
            title2: "os essenciais da sua viagem esperam por",
            title3: "você",
            subtitle: "Seu destino definitivo para tudo que ajuda a celebrar e lembrar sua experiência de viagem.",
            tukTuk: "Tuk Tuk",
        },
        searchBy: {
            titlePrefix: "Pacotes",
            titleSuffix: "recentes",
            subtitle:
                "Descubra os pacotes mais recentes adicionados à Portugalwaytour e explore oportunidades de viagem únicas cuidadosamente selecionadas para lhe proporcionar experiências inesquecíveis, novos destinos e aventuras exclusivas em todo o mundo.",
            noPackages: "Nenhum pacote recente encontrado.",
            hasDiferencial: "Tem diferencial",
            noReviews: "Sem avaliações",
            viewAll: "Ver todos os pacotes",
        },
        sectionBenefit: {
            titlePrefix: "Nossos",
            titleHighlight: "Benefícios",
            titleSuffix: "e principais vantagens",
            subtitle:
                "A Portugalway, uma operadora de turismo especializada em destinos dos sonhos, oferece uma variedade de benefícios para viajantes.",
            benefits: [
                {
                    title: "Experiências Autênticas",
                    description:
                        "Fuja do turismo tradicional e descubra o Portugal autêntico! Nossos passeios oferecem experiências genuínas explorando a cultura local, a culinária e lugares secretos.",
                },
                {
                    title: "Pacotes de Viagens Personalizados",
                    description:
                        "Crie sua viagem sob medida! Escolha sua experiência e nós cuidamos de tudo: hospedagem, transporte e atividades, para uma viagem personalizada e inesquecível.",
                },
                {
                    title: "Conforto e Segurança",
                    description:
                        "Cuidamos de todos os detalhes: transporte confortável, hospedagem selecionada e acompanhamento de guias profissionais, garantindo tranquilidade do início ao fim da viagem.",
                },
                {
                    title: "Atendimento Dedicado",
                    description:
                        "Desde o primeiro contato até o retorno da sua viagem, você conta com suporte personalizado e uma equipe pronta para atender em português e inglês, com agilidade e atenção total às suas necessidades.",
                },
            ],
        },
        exploreCities: {
            title: "Explore por Cidade",
            subtitle: "Descubra experiências únicas em destinos incríveis",
        },
        placeSection: {
            titlePrefix: "Pacotes",
            titleHighlight: "em tendência",
            subtitle:
                "Explore nossos pacotes de viagem mais populares, cuidadosamente selecionados por suas altas avaliações, avaliações positivas e reservas frequentes de outros viajantes. Encontre sua próxima aventura inesquecível aqui.",
            all: "Todos",
            hasDiferencial: "Tem diferencial",
            noReviews: "Sem avaliações",
            viewAll: "Ver todos os pacotes",
        },
        aboutSection: {
            welcome: "Bem-vindo à Portugalwaytour",
            title: "Explore além do horizonte: descubra as maravilhas do mundo",
            description1: "Na Portugal Way Tour, acreditamos que viajar é transformar. Somos uma agência especializada em experiências turísticas únicas em Portugal, comprometida em revelar o que há de melhor no país — sua cultura, paisagens, história e autenticidade.",
            point1: "Proporcionar viagens memoráveis, com conforto, segurança e encanto. Queremos que cada turista descubra Portugal de forma profunda, com roteiros que misturam tradição, natureza, gastronomia e hospitalidade genuína.",
            point2: "Ser referência de qualidade e confiança no turismo em Portugal, reconhecida por turistas de todo o mundo como sinônimo de profissionalismo e encantamento.",
            learnMore: "Saiba mais",
            reviews: "{{count}}+ Avaliações"
        },
        aboutCounters: [
            { label: "Destinos pelo Mundo", icon: "isax-global5", colorClass: "text-teal" },
            { label: "Reservas Concluídas", icon: "isax-calendar-2", colorClass: "text-purple" },
            { label: "Clientes Globalmente", icon: "isax-tag-user5", colorClass: "text-pink" },
            { label: "Fornecedores Registrados", icon: "isax-status-up5", colorClass: "text-info" },
        ],
        expertSection: {
            popularTitle: "Populares",
            popularSubtitle: "Descubra os serviços mais populares, bem avaliados e frequentemente reservados pelos viajantes.",
            serviceName: "Tuk Tuk Driver",
            loading: "Carregando...",
            reservationsSingular: "reserva",
            reservationsPlural: "reservas",
            viewProfile: "Ver Perfil",
            viewAll: "Ver Todos",
        },
        driverModal: {
            loading: "Carregando...",
            description: "Descrição",
            languages: "Idiomas",
            vehicle: "Veículo",
            seats: "assentos",
            averageRating: "Avaliação Média",
            reviews: "Avaliações",
            packages: "Pacotes",
            noReviews: "Sem avaliações ainda",
            noPackages: "Este motorista não possui pacotes cadastrados"
        },
        testimonialSection: {
            title: "O que dizem os nossos {{highlight}}",
            highlight: "usuários",
            subtitle: "Confira o que nossos viajantes acharam de suas experiências.",
            loading: "Carregando avaliações...",
            noReviews: "Nenhuma avaliação encontrada.",
            noComment: "O usuário não deixou comentário.",
            viewPackage: "Ver detalhes do pacote"
        },
        updateSection: {
            faq: {
                title: "Perguntas {{highlight}}",
                highlight: "Frequentes",
                subtitle: "A Portugalway, uma operadora de turismo especializada em destinos dos sonhos, oferece uma variedade de benefícios para viajantes.",
                questions: [
                    {
                        question: "Como faço para reservar um tour?",
                        answer: "Você pode reservar diretamente pelo nosso site ou entrar em contato conosco por e-mail ou telefone. Após definir o roteiro desejado, passamos um orçamento, confirmamos hotéis e serviços, e solicitamos pagamento conforme política informada."
                    },
                    {
                        question: "É possível personalizar o roteiro?",
                        answer: "Sim! Todos os nossos roteiros são flexíveis. Você escolhe os lugares que quer visitar, a duração, o tipo de hospedagem e, dentro das possibilidades, criamos algo que combine com seu perfil."
                    },
                    {
                        question: "Quais são os idiomas dos guias?",
                        answer: "Temos guias que falam português, inglês e, dependendo do tour, outros idiomas. Informe suas preferências ao reservar para que possamos alocar o guia mais adequado."
                    },
                    {
                        question: "Como é a política de cancelamento?",
                        answer: "Temos uma política de cancelamento que varia conforme o tour, a antecedência e os fornecedores. No momento da reserva, enviamos os termos completos. Pedimos ler com atenção antes de confirmar."
                    },
                    {
                        question: "Quais são as formas de pagamento aceitas?",
                        answer: "Aceitamos transferência bancária internacional, cartão de crédito e, em alguns casos, outros métodos de pagamento."
                    }
                ],
                contactUsText: "Caso não encontre a resposta para sua pergunta em nossas Perguntas Frequentes, entre em contato conosco. Responderemos em breve!",
                contactButton: "Contate-nos",
            },
            support: {
                items: [
                    "Roteiros Personalizados",
                    "Planejamento Completo",
                    "Orientação de Especialistas",
                    "Experiência Local",
                    "Suporte ao Cliente",
                    "Esforços de Sustentabilidade",
                    "Múltiplas Regiões"
                ]
            }
        }
    },
    footer: {
        pages: {
            title: "Páginas",
            settings: "Configurações",
            profile: "Perfil",
            social: "Rede Social",
        },
        company: {
            title: "Empresa",
            about: "Sobre Nós",
            testimonials: "Depoimentos",
            faq: "Perguntas Frequentes",
        },
        support: {
            title: "Suporte",
            contact: "Fale Conosco",
            privacy: "Política de Privacidade",
            terms: "Termos e Condições",
            chat: "Atendimento via Chat",
        },
        services: {
            title: "Serviços",
            tuktuk: "Tuk Tuk",
            winery: "Vinícola",
            restaurant: "Restaurante",
            car: "Carro",
            hippotrip: "Hippotrip",
            bike: "Bicicleta",
        },
        bottom: {
            copyright: "Copyright © 2025. Todos os direitos reservados,",
            brand: "Portugalwaytour",
            social: [
                { icon: "fa-brands fa-facebook", link: "#" },
                { icon: "fa-brands fa-x-twitter", link: "#" },
                { icon: "fa-brands fa-instagram", link: "#" },
                { icon: "fa-brands fa-linkedin", link: "#" },
                { icon: "fa-brands fa-pinterest", link: "#" },
            ],
            cards: [
                "assets/img/icons/card-01.svg",
                "assets/img/icons/card-02.svg",
                "assets/img/icons/card-03.svg",
                "assets/img/icons/card-04.svg",
                "assets/img/icons/card-05.svg",
                "assets/img/icons/card-06.svg",
            ],
        },
    },

    auth: {
        registerModal: {
            title: "Acesse sua conta",
            subtitle: "Digite seu e-mail para fazer login ou criar uma conta",
            emailLabel: "E-mail",
            emailPlaceholder: "Digite seu e-mail",
            sendTestCode: "Enviar código de teste",
            sendEmailCode: "Enviar código por e-mail",
            codeLabel: "Código de verificação",
            codePlaceholder: "Digite o código",
            verifyAndLogin: "Verificar e Entrar",
            testCodeSuccess: "Código de teste '123456' gerado. Use para login.",
            testCodeError: "Erro ao gerar código de teste.",
            emailSent: "Código enviado para o seu e-mail!",
            emailError: "Erro ao enviar código por e-mail.",
            loginSuccess: "Login realizado com sucesso!",
            invalidCode: "Código inválido ou expirado.",
            or: "Ou",
            google: "Google",
            facebook: "Facebook",
            reminderTitle: "Complete seu perfil",
            reminderText: "Não se esqueça de completar seu perfil para aproveitar todos os recursos da plataforma!",
            gotIt: "Entendido",
        },
    },
    companyRegisterModal: {
        title: "Registro de Empresa",
        step1: "Por favor, insira seu e-mail pessoal para criar uma conta do administrador da empresa. Você usará esta conta para gerenciar o perfil da empresa.",
        step2: "Enviamos um código de verificação para seu e-mail. Insira-o abaixo para verificar sua identidade.",
        step3: "Agora preencha os dados da sua empresa. O e-mail da empresa deve ser um contato corporativo (ex.: info@empresa.com).",

        personalEmail: "Seu e-mail pessoal",
        sendTestCode: "Enviar código de teste",
        sendEmailCode: "Enviar código por email",

        verificationCode: "Código de verificação",
        verifyCode: "Verificar código",

        companyEmail: "E-mail da empresa",
        companyName: "Nome da empresa",
        nif: "NIF",
        nib: "NIB",
        permanentCertificate: "Número da certidão permanente",
        phone: "Telefone",
        street: "Rua",
        city: "Cidade",
        postalCode: "Código postal",
        country: "País",
        companyDescription: "Breve descrição da empresa",
        servicesProvided: "Serviços oferecidos",

        contractTitle: "Contrato da Empresa",
        acceptContract: "Aceito o contrato da empresa",
        finishRegistration: "Finalizar registro",

        messages: {
            "Test code sent successfully. Use '123456'.": "Código de teste enviado com sucesso. Use '123456'.",
            "Verification email sent successfully.": "Código enviado por email com sucesso.",
            "Verification successful.": "Verificação realizada com sucesso.",
            "Company registered and contract accepted successfully!": "Empresa registrada e contrato aceito com sucesso!",
            testStepMessage: "Código de teste enviado com sucesso. Use '123456'.",
            emailStepMessage: "Um código de verificação foi enviado para seu e-mail. Insira-o abaixo."
        },

        errors: {
            "Failed to send the verification code.": "Falha ao enviar o código de verificação.",
            "Invalid or expired code.": "Código inválido ou expirado.",
            "Please fill all required fields.": "Por favor, preencha todos os campos obrigatórios.",
            "You must accept the contract to register the company.": "Você deve aceitar o contrato para registrar a empresa.",
            "You must be logged in to register the company.": "Você deve estar logado para registrar a empresa.",
            "Failed to register the company or accept the contract.": "Falha ao registrar a empresa ou aceitar o contrato."
        }
    },
    chooseUsSection: {
        title: "Por que nos Escolher?",
        cards: [
            {
                title: "Conveniência",
                description: "Planeje toda a sua viagem a partir de uma única plataforma, economizando tempo e esforço. Chega de ficar alternando entre diferentes sites."
            },
            {
                title: "Garantia do melhor preço",
                description: "Trabalhamos com parceiros de viagem confiáveis ​​para oferecer a você as melhores ofertas, seja reservando um voo, hotel ou aluguel de carro."
            },
            {
                title: "Suporte ao cliente",
                description: "Nossa equipe de suporte dedicada está à sua disposição 24 horas por dia, 7 dias por semana, garantindo que seus planos de viagem ocorram sem problemas do início ao fim."
            },
            {
                title: "Experiências de viagem personalizadas",
                description: "Quer você esteja viajando a negócios, férias em família ou uma aventura solo, oferecemos opções que atendem a todas as necessidades."
            }
        ]
    },

    contactUsSection: {
        breadcrumb: {
            home: "Início",
            pages: "Páginas",
            contactUs: "Contato"
        },
        title: "Entre em contato com nossa equipe de suporte dedicada",
        description: "Nossa equipe está pronta para ajudar. Sua satisfação é nossa prioridade.",
        info: [
            {
                label: "Endereço de email",
                value: "portugaltourway@gmail.com"
            },
            {
                label: "Número de telefone",
                value: "INSERT NUMBER"
            },
            {
                label: "Nossa localização",
                value: "INSERT RUA , Almada - Portugal"
            }
        ],
        supportCard: {
            title: "Precisa de suporte?",
            textLoggedOut: "Para entrar em contato com nossa equipe de suporte e abrir tickets, você precisa criar uma conta ou fazer login. Depois disso, terá acesso completo à sua dashboard de suporte, onde poderá acompanhar e gerenciar suas solicitações.",
            textLoggedIn: "Você já está logado! Agora você pode abrir um novo ticket de suporte ou acompanhar os tickets existentes diretamente na sua dashboard.",
            btnLoggedOut: "Criar Conta / Fazer Login",
            btnLoggedIn: "Abrir Ticket na Dashboard"
        }
    },

    sidebar: {
        main: "Principal",
        dashboard: "Painel",
        myBookings: "Minhas Reservas",
        myReviews: "Avaliações",
        wishlist: "Lista de Desejos",
        support: "Suporte",
        finance: "Financeiro",
        wallet: "Carteira",
        payments: "Pagamentos",
        account: "Conta",
        myProfile: "Meu Perfil",
        notifications: "Notificações",
        settings: "Configurações",
        preferences: "Preferências",
        logout: "Sair",
    },

    agentSidebar: {
        dashboard: "Painel",
        bookings: "Reservas",
        tukTukBookings: "Reservas de Tuk Tuk",
        hotelBookings: "Reservas de Hotel",
        carBookings: "Reservas de Carro",
        cruiseBookings: "Reservas de Cruzeiro",
        tourBookings: "Reservas de Passeio",
        flightBookings: "Reservas de Voos",
        enquiries: "Consultas",
        earnings: "Ganhos",
        reviews: "Avaliações",
        support: "Suporte",
        serviceEnrollment: "Cadastro de Serviços",
        drivers: "Motoristas",
        tukTukVehicles: "Veículos de Tuk Tuk",
        settings: "Configurações",
        logout: "Sair",
    },

    dashboardCards: {
        totalBookings: "Total de Pacotes Comprados",
        totalListings: "Total de Pacotes",
        totalEarnings: "Total Ganhos",
        totalReviews: "Total Avaliações",
    },

    recentlyadded: {
        titulo: "Adicionado recentemente",
    },

    BookingsStatistics: {
        titulo: "Estatísticas de reservas",
        loading: "Carregando estatísticas...",
        none: "Nenhuma reserva registrada ainda.",
    }
};

